/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProductTypeRequestModel model module.
 * @module model/ProductTypeRequestModel
 * @version v1.0.0
 */
class ProductTypeRequestModel {
    /**
     * Constructs a new <code>ProductTypeRequestModel</code>.
     * @alias module:model/ProductTypeRequestModel
     */
    constructor() { 
        
        ProductTypeRequestModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProductTypeRequestModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProductTypeRequestModel} obj Optional instance to populate.
     * @return {module:model/ProductTypeRequestModel} The populated <code>ProductTypeRequestModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProductTypeRequestModel();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * name
 * @member {String} name
 */
ProductTypeRequestModel.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
ProductTypeRequestModel.prototype['seq'] = undefined;






export default ProductTypeRequestModel;

